import { render, staticRenderFns } from "./SinglePatient.vue?vue&type=template&id=6b954b5b&scoped=true&"
import script from "./SinglePatient.vue?vue&type=script&lang=js&"
export * from "./SinglePatient.vue?vue&type=script&lang=js&"
import style0 from "./SinglePatient.vue?vue&type=style&index=0&id=6b954b5b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b954b5b",
  null
  
)

export default component.exports